import { render, staticRenderFns } from "./CompanyRequests.vue?vue&type=template&id=5c4e7c4e"
import script from "./CompanyRequests.vue?vue&type=script&lang=js"
export * from "./CompanyRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports